
export const RD1Address='0:28be06b9b0b0013ac7aa06f4274c1b11ccc0dd8ba44c1a4d622e70c93e7b95d4'
export const RD2Address='0:09b79d7417c7e3a70d73558b650b1fcd36d7cd899f04ebf1615236005356e637'
export const roundDuration=60*60 * 6 //6 hours
export const network: 'localnet' | 'mainnet' | 'testnet' = 'mainnet' 
